import * as Yup from 'yup';

const requiredMessage = `This field is required`;

export const maxCredibleValidationSchema = () => {
  const fields: any = {
    inheritance: Yup.string().trim().nullable(),
    prevalence: Yup.string().trim().required(requiredMessage).nullable(),
    allelic_heterogeneity: Yup.number().required(requiredMessage),
    genetic_heterogeneity: Yup.number().required(requiredMessage),
    penetrance: Yup.number().required(requiredMessage),
  };

  return Yup.object().shape(fields);
};
